import { Injectable, Injector } from "@angular/core";
import { StateService, Tracker } from "flux-core";
import { UserLocator } from "flux-user";
import { combineLatest } from "rxjs";
import { distinctUntilChanged, filter, map } from "rxjs/operators";
import { DiagramLocatorLocator } from "../diagram/locator/diagram-locator-locator";
import { DiagramPlanPermManager } from "./diagram-plan-perm-manager";

/**
 * Main plan permission manager class which select and
 * handle current plan permission run in the app
 * 
 * @author sajeevah
 * @since  2025-08-18
 */
@Injectable()
export class PlanPermManager extends DiagramPlanPermManager {


    constructor(
        protected userLocator: UserLocator,
        protected injector: Injector,
        protected state: StateService<any, any>,
        protected ll: DiagramLocatorLocator,
    ) {
        super( userLocator, injector, state, ll );
        this.setCurrentPlan();
    }

    protected currentPlanSubscription() {
        return combineLatest([
            this.userPlanSubscription(),
            this.diagramPlanSubscription(),
        ]).pipe(
            map(([ userPlan, diagramPlan ]) => ( diagramPlan ? diagramPlan : userPlan ))
        );
    }

    /**
     * Set current plan base on user subscription
     */
    protected setCurrentPlan() {
        this.currentPlanSubscription().pipe(
            distinctUntilChanged(),
            filter( plan => !!plan ),
        ).subscribe( plan => {
            this.planId = plan.id;
            this.planType = plan.type;
            this.permissions = plan.permissions;
            this.isPaidDiagramSub.next( this.planType.includes( 'DIAGRAM' ));
            Tracker.setGlobalProperty( 'plan', this.planType );
        });
    }
    
}